<template>
<div>


  <div id="footer-section" class="container-fluid p0">

    <div id="social-section">
        <div class="container">
            <div class="row">
              <br><br><br>
               <!--  <div class="col-md-12 ">
                    <embed class="icon-star-and-cin" src="https://flxassets.s3-accelerate.amazonaws.com/2018/images/icon-star-and-cin.svg" type="image/svg+xml">
                    <embed class="icon-soda" src="https://flxassets.s3-accelerate.amazonaws.com/2018/images/icon-soda.svg" type="image/svg+xml"> </div> -->
<!--                <div class="col-md-12 text-center"> -->
<!--                  -->
<!--                    <div class="text-center">-->
<!--                        <ul class="nav navbar-nav menu-rrss">-->
<!--                            <li>-->
<!--                                <a rel="noopener" aria-label="Facebook" target="_blank" href="https://www.facebook.com/flixlatino">-->

<!--                                  <img alt="Facebook" width="40" height="40" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2018/images/RRSS-01.png')" >-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <a rel="noopener" aria-label="Instagram" target="_blank" href="https://www.instagram.com/flixlatino/">-->
<!--                                  <img alt="Instagram" width="40" height="40" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2018/images/RRSS-02.png')" >-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li style="margin-left: 10px; margin-right:10px;">-->
<!--                                <a rel="noopener" aria-label="Youtube" target="_blank" href="https://www.youtube.com/flixlatino">-->
<!--                                  <img alt="Youtube" width="40" height="40" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2018/images/RRSS-04.png')" >-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <a rel="noopener" aria-label="Twitter" target="_blank" href="https://twitter.com/FlixLatino">-->
<!--                                  <img alt="Twitter" width="40" height="40" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2018/images/RRSS-03.png')" >-->
<!--                              </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>


    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center footer-cont">
                    <div class="text-center" v-html="$parent.lang.footerLinks"> 
                     
                    </div>
                    <div class="text-center">{{$parent.lang.tollFree}}</div>
                    <div class="copyright" v-html="copyright"></div>
                </div>
            </div>
        </div>
    </div>


     

  </div>
</div>
</template>


<script>




export default {
  name: 'flixFooter',
  components: {
  },
  data(){ return {
    }
  },
  created: function () {
    
  },
  updated: function(){

  },
  computed:{
    copyright: function(){
      let d = new Date();
      let n = d.getFullYear();
      return this.$parent.lang.copyright.replace('YYYY',n);
    }
  },
  
  methods:{

  }
  
}
</script>
<style type="text/css">
.descriptive{
  font-size: 15px;
  margin: 10px 0;
      font-family: Yanone Kaffeesatz,DINCondensed-Bold,Arial Narrow,sans-serif;
    font-size: 14px;
    color: #010e23;
}
#keys{
  background: #626e73;
  color: #fff;
  padding: 40px 0;
}
.white-text{
 color: #fff;
    font-size: 23px;
    line-height: 1.4em;
}
.white-text .bigg{
  font-size: 48px;
  color: #fff;
}
.white-text li{
  color: #fff;
}
</style>